/**
 * SEO Sprint 2 — Destination page: Aruba (/shipping-to-aruba).
 * CMS-driven via `destination_page_settings` slug=aruba.
 */
import React from "react";
import DestinationPage from "../components/DestinationPage";

const ARUBA_FALLBACK = {
  display_name: "Aruba",
  country_code: "AW",
  url_path: "/shipping-to-aruba",
  page_banner: {
    eyebrow: "Bestemming: Aruba",
    title: "Verzenden naar",
    highlight: "Aruba",
    subtitle:
      "Stuur een pakket of cargo van Nederland naar Aruba — zeevracht voor voordelig volume, luchtvracht voor snellere routes. Persoonlijke begeleiding van pickup in Nederland tot levering op Aruba.",
    badges: [
      { icon: "ship",    label: "Zee- en luchtvracht" },
      { icon: "package", label: "Pakketten t/m cargo" },
      { icon: "support", label: "Persoonlijke begeleiding" },
    ],
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  intro: {
    eyebrow: "Over verzendingen naar Aruba",
    title: "Hoe wij uw zending naar Aruba regelen",
    body:
      "Wij verzorgen verzendingen van Nederland naar Aruba voor particulieren, gezinnen en bedrijven. Of u nu een paar dozen stuurt, een complete verhuizing plant of regelmatig zakelijke cargo verstuurt — wij stemmen de route, de documenten en de aflevering af op uw zending. Voor pakketten kiest u doorgaans voor luchtvracht; voor grotere volumes en verhuisgoederen is zeevracht meestal voordeliger.\n\nBeschikbaarheid, tarieven en procedures kunnen per bestemming en type zending verschillen. Vraag actuele routebeschikbaarheid aan — onze medewerkers helpen u graag met de juiste verzendoptie.",
  },
  service_blocks: { items: [] },
  faq: { items: [] },
  cta_band: {
    title: "Klaar om naar Aruba te verzenden?",
    description:
      "Vraag een vrijblijvende offerte aan met uw zendingdetails — wij adviseren binnen 1 werkdag de juiste route, kosten en documenten.",
    cta_primary_label: "Vraag offerte aan",
    cta_primary_url: "/contact?get-quote=1#quote-form",
    cta_secondary_label: "Bel ons",
    cta_secondary_url: "tel:+31488235999",
  },
  seo: {
    title: "Pakket naar Aruba sturen | Zee- en luchtvracht | 5999Cargo",
    description:
      "Stuur pakketten of cargo van Nederland naar Aruba. Zee- en luchtvracht, pickup in NL, documenten en aflevering — alles via 5999Cargo Group Europe.",
    keywords:
      "pakket naar Aruba sturen, zeevracht Aruba, luchtvracht Aruba, vracht naar Aruba, shipping to Aruba from Netherlands",
  },
};

export default function ShippingToArubaPage() {
  return <DestinationPage slug="aruba" fallback={ARUBA_FALLBACK} />;
}
